import {
  SET_CART_PROPS,
  CLEAR_CART_PROPS,
  SET_INITIAL_DATE_TIMES,
  SET_NEW_EVENT_CART_PROPS,
  SET_CART_TRANSACTION_PROPS,
  INIT_CART_PROPS,
  REFRESH_CART_ITEMS,
} from 'Constants/redux';
import { isSsr } from 'HelperFunctions/ssr';
import { restoreCart } from 'HelperFunctions/general';
import cloneDeep from 'lodash/cloneDeep';

const cartEvent = restoreCart();

const INITIAL_CART = {
  eventStartTime: cartEvent ? cartEvent.eventStartTime : null,
  eventEndTime: cartEvent ? cartEvent.eventEndTime : null,
  eventStart: cartEvent ? cartEvent.eventStart : null,
  eventEnd: cartEvent ? cartEvent.eventEnd : null,
  name: '',
  inventoryOnCart: [],
  customerContactPhone: '',
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  deliveryType: 'none',
  deliveryAddressLocationName: '',
  deliveryAddressStreetAddress1: '',
  deliveryAddressStreetAddress2: '',
  deliveryAddressCity: '',
  deliveryAddressLocale: '',
  deliveryAddressPostalCode: '',
  preferredDeliveryWindow: '',
  preferredPickupWindow: '',
  pickupSameAsDelivery: true,
  pickupAddressLocationName: '',
  pickupAddressStreetAddress1: '',
  pickupAddressStreetAddress2: '',
  pickupAddressCity: '',
  pickupAddressLocale: '',
  pickupAddressPostalCode: '',
  editingEvent: false,
};

const INITIAL_STATE = {
  event: cartEvent || cloneDeep(INITIAL_CART),
  newEvent: cloneDeep(INITIAL_CART),
  newCustomer: {
    firstName: '',
    lastName: '',
    email: '',
  },
  loading: false,
  addingItems: false,
};

export default (state = INITIAL_STATE, action) => {
  let newState;
  switch (action.type) {
    case SET_CART_PROPS:
      const newEvent = {
        ...state.event,
        ...action.payload,
      };
      newState = { ...state, event: newEvent };
      break;
    case CLEAR_CART_PROPS:
      newState = {
        ...INITIAL_STATE,
        event: { ...INITIAL_CART }
      };
      break;
    case SET_INITIAL_DATE_TIMES:
      const now = new Date();
      const defaultStart = new Date(action.payload.defaultStart);
      const defaultEnd   = new Date(action.payload.defaultEnd);
      const newStartTime = new Date();
      newStartTime.setHours(defaultStart.getHours(), defaultStart.getMinutes(), 0, 0);
      const newEndTime = new Date();
      newEndTime.setHours(defaultEnd.getHours(), defaultEnd.getMinutes(), 0, 0);
    
      const isPast = (d) => d instanceof Date && !isNaN(d) && d < now;
    
      const newEventPayload = {
        ...state.event,
        eventStartTime: state.event.eventStartTime || newStartTime,
        eventEndTime: state.event.eventEndTime || newEndTime,
        eventStart: isPast(state.event.eventStart)
          ? new Date()
          : (state.event.eventStart || new Date()),
        eventEnd: isPast(state.event.eventEnd)
          ? new Date()
          : (state.event.eventEnd || new Date()),
      };
    
      newState = { ...state, event: newEventPayload };
      break;
    case SET_NEW_EVENT_CART_PROPS:
      newState = {
        ...state,
        newEvent: { ...state.newEvent, ...action.payload },
      };
      break;
    case SET_CART_TRANSACTION_PROPS:
      newState = {
        ...state,
        ...state.transaction,
        ...action.payload,
      };
      break;
    case REFRESH_CART_ITEMS:
      const products = action.products;
      const cartItems = [...state.event.items];

      cartItems.forEach((item, index) => {
        cartItems[index].product =
          products.find(
            (product) =>
              product.id === item.product?.id &&
              product.productType === item.product?.productType
          ) || item.product;
      });

      const newEventWithRefreshedItems = { ...state.event, items: cartItems };
      newState = { ...state, event: newEventWithRefreshedItems };
      break;
    case INIT_CART_PROPS:
      localStorage.removeItem('cartEvent');
      newState = {
        ...state,
        event: cloneDeep(INITIAL_CART),
        loading: false,
        addingItems: false,
      };
      break;
    default:
      newState = state;
      break;
  }

  if (
    newState.event.inventoryOnCart?.length !== 0 ||
    newState.event.eventStartTime !== INITIAL_CART.eventStartTime ||
    newState.event.eventEndTime !== INITIAL_CART.eventEndTime
  ) {
    if (!isSsr())
      localStorage.setItem('cartEvent', JSON.stringify(newState.event));
  } else {
    if (!isSsr()) localStorage.removeItem('cartEvent');
    newState = {
      event: {
        ...cloneDeep(INITIAL_CART),
        customerContactPhone: newState.event.customerContactPhone,
        redirectUrl: newState.event.redirectUrl,
      },
      newEvent: newState.newEvent,
      newCustomer: newState.newCustomer,
      loading: false,
      addingItems: false,
    };
  }

  return newState;
};
